export const include_attr_config = {
  sv_vintage: ["brena"]
};
